import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import { FORM_STYLES } from "../constants";
import { PageOneFormData } from "../models";

export const SafetyMeasures = () => {
  const { t } = useTranslate();
  const { control } = useFormContext<PageOneFormData>();

  const measures = [
    {
      name: "safetyMeasures.serviceIntroduced" as const,
      label: "adult-patient-assessment.service-introduced-to-patient",
    },
    {
      name: "safetyMeasures.bedRailsUp" as const,
      label: "adult-patient-assessment.bed-rails-up",
    },
    {
      name: "safetyMeasures.roomIntroduced" as const,
      label: "adult-patient-assessment.room-introduced-to-patient",
    },
    {
      name: "safetyMeasures.bedsideArrangement" as const,
      label: "adult-patient-assessment.bedside-arrangement-completed",
    },
  ];

  return (
    <Grid md={4} xs={12} sx={{ padding: "0px", paddingRight: "20px" }}>
      <Box
        sx={{
          border: FORM_STYLES.sectionBorder,
          borderRadius: FORM_STYLES.sectionBorderRadius,
          padding: FORM_STYLES.sectionPadding,
        }}
      >
        <Grid
          sx={{
            backgroundColor: FORM_STYLES.titleBackgroundColor,
            color: FORM_STYLES.titleColor,
            borderRadius: FORM_STYLES.titleBorderRadius,
          }}
        >
          <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
            {t("adult-patient-assessment.basic-safety-measures")}
          </ByzMuiTypography>
        </Grid>
        <Stack direction={"column"} sx={{ paddingTop: "20px" }}>
          {measures.map((measure) => (
            <Stack key={measure.name} direction={"row"} sx={{ paddingTop: "10px" }}>
              <Controller
                name={measure.name}
                control={control}
                render={({ field }) => (
                  <ByzMuiCheckBox
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                )}
              />
              <ByzMuiTypography
                fontWeight={"400"}
                sx={{ display: "flex", alignItems: "center" }}
              >
                {t(measure.label)}
              </ByzMuiTypography>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Grid>
  );
};
